"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var treeDataUtil_1 = require("@features/ItemCommon/components/common/SelectTree/treeDataUtil");
var TreeModal_1 = __importDefault(require("@features/ItemCommon/components/common/SelectTree/Tree/TreeModal"));
var clickOutsideHook_1 = require("@common/hooks/clickOutsideHook");
var SelectItem_1 = __importDefault(require("@features/ItemCommon/components/common/SelectTree/Select/SelectItem"));
var useKeyPress_1 = __importDefault(require("@common/hooks/useKeyPress"));
function TreeOrSelect(_a) {
    var categories = _a.categories, current = _a.current, resetToOriginalValue = _a.resetToOriginalValue, setCategory = _a.setCategory, setMode = _a.setMode, treeMode = _a.treeMode;
    var selectContainerRef = (0, react_1.createRef)();
    var escapePress = (0, useKeyPress_1.default)('Escape', selectContainerRef);
    var tabPress = (0, useKeyPress_1.default)('Tab', selectContainerRef);
    (0, react_1.useEffect)(function () {
        if (escapePress || tabPress) {
            (function () { return setMode('VIEW'); });
        }
    }, [escapePress, tabPress]);
    (0, clickOutsideHook_1.useClickOutside)(selectContainerRef, function () { return setMode('VIEW'); });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        treeMode === treeDataUtil_1.TreeOpenMode.TREE && (react_1.default.createElement(TreeModal_1.default, { categories: categories, current: current, resetToOriginalValue: resetToOriginalValue, setCategory: setCategory })),
        (treeMode === treeDataUtil_1.TreeOpenMode.TWO_LEVEL_DROPDOWN || treeMode === treeDataUtil_1.TreeOpenMode.ONE_LEVEL_DROPDOWN) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "item-detail-field-value-container item-detail-field-clickable" },
                react_1.default.createElement("div", { className: "item-detail-field__value--disabled" }, current.name),
                react_1.default.createElement("i", { className: "job-category-select-icon implioicons-arrow-down" })),
            react_1.default.createElement("div", { className: "select-container", ref: selectContainerRef },
                react_1.default.createElement(SelectItem_1.default, { items: categories, setValue: setCategory, selectMode: treeMode }))))));
}
exports.default = TreeOrSelect;
